import i18nMixin from '../i18nMixin';
import * as landRegistryActions from '../../actions/landRegistry';
import authMixin from '../authMixin';

export function init(tag) {
  tag.mixin(authMixin);
  tag.mixin(i18nMixin);

  tag.formSubmit = function (event: Event) {
    event.preventDefault();
    let query = tag.refs.numberInput.value.trim();

    if (query.includes('/')) {
      query = convertToRealtyKey(query);
    }

    landRegistryActions.retrieveCreationOfRights(query);
    tag.update();
  };

  function convertToRealtyKey(mappingAuthorityKey) {
    const split = mappingAuthorityKey.split('-');
    const split1 = split[0].split('/');
    const split2 = split[1].split('/');

    const year = split1[0];
    const docNo = split1[1];
    const rightNo = split2[0];
    const office = split2[1];

    return office + '-' + year + '-' + docNo + '-' + rightNo;
  }
}
